export type SecretValue = {
	value: string | null;
	containsNewValue: boolean;
};

export enum AppCategory {
	Productivity = 1,
	Office = 2,
	Communication = 3,
	Web = 4,
	Social = 5,
	Entertainment = 6,
	News = 7,
	Finance = 8,
	Education = 9,
	Medical = 10,
	Other = 11,
	Custom = 12
}

export enum AppColorKind {
	Inherit = 0,
	Custom = 1,
	Primary = 2,
	Header = 3
}

type InheritAppColorViewModel = { kind: AppColorKind.Inherit; };
type HeaderAppColorViewModel = { kind: AppColorKind.Header; };
type PrimaryAppColorViewModel = { kind: AppColorKind.Primary; };
type CustomAppColorViewModel = { kind: AppColorKind.Custom; value: string; };

export type AppColorViewModel = InheritAppColorViewModel |
	HeaderAppColorViewModel |
	PrimaryAppColorViewModel |
	CustomAppColorViewModel;

type InheritSaveAppColorModel = { kind: AppColorKind.Inherit; };
type HeaderSaveAppColorModel = { kind: AppColorKind.Header; };
type PrimarySaveAppColorModel = { kind: AppColorKind.Primary; };
export type CustomSaveAppColorModel = { kind: AppColorKind.Custom; value: string | undefined; };

export type SaveAppColorModel = InheritSaveAppColorModel |
	HeaderSaveAppColorModel |
	PrimarySaveAppColorModel |
	CustomSaveAppColorModel;

export enum AppType {
	Unknown = -1,
	Url = 0,
	Email = 1,
	Documents = 2,
	Office365Word = 5,
	Office365Excel = 6,
	Office365PowerPoint = 7,
	Office365OneNote = 8,
	Office365LyncMeeting = 9,
	Office365PeopleScreen = 10,
	Office365Calendar = 11,
	CitrixXenApp = 15,
	Rss = 17,
	AzureApp = 20,
	ClientlessRdp = 21,
	PowerBi = 23,
	Yammer = 24,
	Embed = 25,
	ToDo = 26,
	Google = 27,
	TopDesk = 28,
	ConnectWise = 29,
	Teams = 30,
	SharePoint = 31,
	AddressBook = 32,
	HowTo = 33,
	Hub = 34,
	LocalApp = 35,
	WindowsVirtualDesktop = 36,
	VilansKick = 37,
	Birthday = 38,
	Autotask = 39,
	YouTube = 40,
	NedapOns = 41,
	Afas = 42,
	Zaaksysteem = 43,
	Zermelo = 44,
	ZenyaDoc = 45,
	Liquit = 46,
	VmwareHorizonApp = 47,
	Magister = 48,
	Integration = 49
}

export enum CalendarDestinationApp {
	Workspace = 0,
	OutlookWebApp = 1
}

export enum DestinationWindow {
	NewWindow = 0,
	CurrentWindow = 1
}

export enum ClientlessRdpDestinationWindow {
	NewWindow = 0,
	NewPopOutWindow = 1
}

export enum EmailDestinationApp {
	Email = 0,
	OutlookWebApp = 1
}
